/**
 * Utility functions for CSV export
 */

import { authenticatedFetch } from '../services/api/apiClient'
import { apiEndpoints } from '../consts'
import logger from './logger'

const CALLS_EXPORT_ENDPOINT = apiEndpoints.callsExportCsv

/**
 * Downloads call data as a CSV file with loading state management
 *
 * @param {Object} options - Options for CSV download
 * @param {string} options.campaignName - Optional campaign name to filter by
 * @param {Date} options.startDate - Start date for filtering
 * @param {Date} options.endDate - End date for filtering
 * @param {Function} options.setLoading - Function to set loading state
 * @returns {Promise<void>}
 */
export const downloadCallsAsCsv = async ({ campaignName, startDate, endDate, setLoading }) => {
  if (!startDate || !endDate || !setLoading) {
    logger.error('Missing required parameters for CSV download')
    return
  }

  try {
    setLoading(true)

    const params = new URLSearchParams()
    if (campaignName) params.append('campaignName', campaignName)
    params.append('startDate', startDate.toISOString())
    params.append('endDate', endDate.toISOString())

    const apiUrl = `${CALLS_EXPORT_ENDPOINT}?${params.toString()}`

    const response = await authenticatedFetch(apiUrl)
    if (!response.ok) throw new Error(`Error: ${response.status}`)

    const blob = await response.blob()
    const downloadUrl = window.URL.createObjectURL(blob)
    const filename = `call_data_${campaignName || 'all'}_${new Date().toISOString().slice(0, 10)}.csv`

    const link = document.createElement('a')
    link.href = downloadUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()

    window.URL.revokeObjectURL(downloadUrl)
    document.body.removeChild(link)
  } catch (error) {
    logger.error('CSV download failed:', error)
    alert('Failed to download CSV. Please try again.')
  } finally {
    setLoading(false)
  }
}

export default {
  downloadCallsAsCsv
}
